import _ from "underscore";

// returns an array of tag objects
// idList: an array of strings
export const lookupTags = (params) => {
	const { tagLibrary, idList } = params;
	const tags = [];

	if (idList) {
		_.each(idList, (id) => {
			const match = _.find(tagLibrary, (tag) => {
				return tag.id === id;
			});
			if (match) {
				tags.push(match);
			}
		});
	}

	return tags;
};
